import { btnMd, btnSm, btnXs } from './Button.module.sass';

export const SIZE_CLASS_NAMES = {
  md: btnMd,
  sm: btnSm,
  xs: btnXs
};
